import { FC } from 'react';
import { styled } from '@mui/material';
import { LinkInteraction } from '../../services/sendLinkManager';
import { VerticalSpace } from '@chargeafter/ui';
import QrCode from 'react-qr-code';
import { CountdownClock } from '../../components/CountDownClock';
import { ContentContainer } from './ContentContainer';
import { SendEmailLink } from './SendEmailLink';
import { RefreshButton } from './RefreshButton';
import {
  useGetInteractionOptions,
  useGetMerchantConfigurationOptions,
} from '../../services/configManager';

const StyledClock = styled(CountdownClock)({
  fontSize: 'x-large',
  letterSpacing: '2px',
});

type QrCodeScreenProps = {
  linkInteraction: LinkInteraction;
  link: string;
  timeLeft: number;
  onRefresh: () => void;
  onSendEmail: () => void;
};

export const QrCodeScreen: FC<QrCodeScreenProps> = ({
  link,
  timeLeft,
  onRefresh,
  onSendEmail,
  linkInteraction,
}) => {
  const { citiExperience } = useGetMerchantConfigurationOptions();
  const { applyLink, checkoutLink, expressCheckoutLink } =
    useGetInteractionOptions();

  const showLink =
    citiExperience ||
    (linkInteraction.action === 'apply' && applyLink) ||
    (linkInteraction.action === 'checkout' && checkoutLink) ||
    (linkInteraction.action === 'expressCheckout' && expressCheckoutLink);
  return (
    <ContentContainer>
      <QrCode value={link} size={128} data-testid="qr-code" />
      <VerticalSpace units={4} />
      <StyledClock
        countdownInSeconds={timeLeft}
        description="Time left"
        descriptionProps={{
          sx: { fontSize: 'medium', letterSpacing: 'normal' },
        }}
      />
      <RefreshButton onRefresh={onRefresh} />
      {showLink && (
        <SendEmailLink
          action={linkInteraction.action}
          onSendEmail={onSendEmail}
        />
      )}
    </ContentContainer>
  );
};
